$(document).ready(function () {
    const loadMoreContainer = $('#load-more-container');
    const loadMoreBtn = $('.load-more-btn');
    let currentPageNb = 1;

    function loadMore(hasMoreProduct) {
        if (hasMoreProduct) {
            loadMoreContainer.show();
        } else {
            loadMoreContainer.hide();
        }
    }

    loadMoreBtn.on('click', function () {
        let flyerLoadMoreAjaxUrl = loadMoreBtn.attr('data-load-more-ajax-url');
        const currentPageUrl = loadMoreBtn.attr('data-current-page-url');
        // Extraire les paramètres (sortOrder, filter, etc.)
        const urlParams = new URLSearchParams(currentPageUrl.split('?')[1]);
        const sortOrder = urlParams.get('sortOrder');
        const filter = urlParams.get('filter');
        const page = currentPageNb;

        TINK.inProgress($("body"));

        $.ajax({
            url: flyerLoadMoreAjaxUrl,
            type: 'GET',
            headers: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json',
            data: {
                currentPage: page,
                sortOrder: sortOrder,
                filter: filter
            },
            success: function (data) {
                const $fragment = $(data);
                $('.plpGridList ').append($fragment);
                currentPageNb++;
                const $div = $fragment.filter('[data-has-more-product-to-load]');
                const hasMoreProduct = $div.attr('data-has-more-product-to-load') === 'true';
                loadMore(hasMoreProduct);
            },
            error: function () {
                console.error('Erreur lors du chargement des produits');
            },
            complete: function () {
                TINK.stopProgress($("body"));
            }
        });
    });

    const hasMoreInit = loadMoreBtn.attr('data-has-more-product-to-load-init') === 'true';
    loadMore(hasMoreInit);
});